import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import {LoginService} from './login.service';
import {ProblemDetailDto} from '../dto/problem-detail-dto';
import UiSwal from '../utils/ui/misc/ui-swal';

@Injectable({
    providedIn: 'root'
})
export class AplicationErrorHandler extends ErrorHandler {

    constructor(
        private injector: Injector,
        private zone: NgZone,
    ) {
        super();
    }

    override handleError(errorResponse: HttpErrorResponse | any) {
        const toastr = this.injector.get(ToastrService);
        const loginService = this.injector.get(LoginService);

        if (errorResponse?.message?.includes('ExpressionChangedAfterItHasBeenCheckedError')) {
            console.warn('Angular ExpressionChangedAfterItHasBeenCheckedError (ignorado): ', errorResponse);
            return;
        }

        if (errorResponse instanceof HttpErrorResponse) {
            this.handleHttpError(errorResponse, toastr, loginService);
        } else {
            super.handleError(errorResponse);
        }
    }

    /**
     * Handles specific HTTP error responses.
     */
    private handleHttpError(error: HttpErrorResponse, toastr: ToastrService, loginService: LoginService): void {
        if (error.status === 401 || error.status === 403) {
            //this.showErrorAlert('Acesso Negado', 'Sessão expirada ou sem permissão. Faça o login novamente.');
            toastr.error('Sessão expirada ou sem permissão. Faça o login novamente.', 'Acesso Negado');
            this.zone.run(() => loginService.logout());
            return;
        }
        const errorBody = error.error;
        if (this.isProblemDetail(errorBody)) {
            if (errorBody.validation_errors && errorBody.validation_errors.length > 0) {
                const listaErros = errorBody.validation_errors.join('\n');
                this.zone.run(() => {
                    this.showErrorAlert(errorBody.title, listaErros);
                    //toastr.error(errorBody.title, listaErros);
                });
            } else {
                this.zone.run(() => {
                    this.showErrorAlert(errorBody.title, errorBody.detail);
                    //toastr.error(errorBody.detail, errorBody.title);
                });
            }
        } else {
            switch (error.status) {
                case 400:
                    toastr.error('Requisição inválida. Verifique os dados enviados.', 'Erro 400');
                    break;
                case 404:
                    toastr.error('O recurso solicitado não foi encontrado.', 'Erro 404');
                    break;
                case 409:
                    toastr.error('Conflito de dados. O item já pode existir ou foi modificado.', 'Erro 409');
                    break;
                case 500:
                    toastr.error('Ocorreu um erro interno no servidor.', 'Erro 500');
                    break;
                default:
                    toastr.error('Algo inesperado ocorreu na comunicação com o servidor.');
            }
        }
        super.handleError(error);
    }

    private isProblemDetail(body: any): body is ProblemDetailDto {
        return body && body.type && body.title && body.status && body.detail;
    }

    private showErrorAlert(title: string, text: string) {
        UiSwal.fire({
            title: title,
            text: text,
            icon: 'warning',
            confirmButtonText: 'Ok'
        }).then();
    }
}
